import { APIClient, getLoggedinUser, setAuthorization } from './apiCore';
import * as url from './urls';

const api = new APIClient();

const getProfileDetails = () => {
    const userProfileSession = getLoggedinUser();
    setAuthorization(userProfileSession.data.acces_token);
    return api.get(url.GET_PROFILE_DETAILS);
};

const getSettings = () => {
    const userProfileSession = getLoggedinUser();
    setAuthorization(userProfileSession.data.acces_token);
    return api.get(url.GET_USER_SETTINGS);
};
const updateSettings = (field: string, value: any) => {
    return api.update(url.UPDATE_ETTINGS, {
        field: field,
        value: value
    });
};

export { getProfileDetails, getSettings, updateSettings };
